import addNotification from 'react-push-notification';

const sendNotification = ({ title, message, onClick }) => {
    if (document?.visibilityState === 'hidden') {
        addNotification({
          title: title || "New Message",
          subtitle: 'You have a new message',
          message: message || '',
          theme: 'darkblue',
          native: true,
          icon: '/favicon.ico',
          onClick: onClick || (() => window.focus()), // Focus the window when clicked
        });
    } else {
        console.log('Tab is active — No notification sent');
    }
};

export default sendNotification;
